import Repository from '../Repository';
import { useToast } from 'vue-toastification';

const resource = '/customer';
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`${resource}`, { params: params });
	},
	counts(params) {
		return Repository.get(`${resource}/counts`, { params: params });
	},
	show(id) {
		return Repository.get(`${resource}/${id}`);
	},
	history(id, payload) {
		return Repository.post(`${resource}/${id}/history`, payload).then((response) => {
			toast.success(`Actividad registrada correctamente.`);
			return response;
		});
	}
}